import React from 'react'
import { connect } from 'react-redux'
import styles from './TabLabel.scss'
import CSSModules from 'react-css-modules'

class TabLabel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {tabLabel, tabIconName, tabChosenValue} = this.props
    let tabIcon = tabIconName != '' ? (<i class={`material-icons ${styles.sidePad}`}>{tabIconName}</i>) : ''
    return (
      <div>
				<div>
          <div class={styles.icon}>
            {tabIcon}
            {tabLabel}
          </div>
				</div>
				<div class={styles.chosenValue}>
					{tabChosenValue}
				</div>
			</div>
    )
  }

}

export default CSSModules(TabLabel, styles)
